export const getPagePattern = path => {
  const regexPattern = path
    .split('/')
    .map(segment => {
      if (segment.startsWith(':')) {
        return '[^/]+';
      }
      return segment;
    })
    .join('/');

  return new RegExp(`^${regexPattern}$`);
};
